import { Alert, Stack } from '@mui/material'
import ContactDetailsSection from '../contacts/ContactDetailsSection'
import { withFlag } from '../contacts/contactLists'
import StepHeader from './StepHeader'

export const CONTACTS_HEADER = 'אילו פרטי קשר תרצו שיופיעו בהודעה שהלקוח יקבל?'

export const CONTACTS_NEXT_HINT = 'לחצו על הבא כדי לסקור ולשלוח את ההודעה'

export const CONTACTS_READ_ONLY_MESSAGE = 'רק משתמש עם הרשאה לניהול הגדרות המשרד יכול לשנות את פרטי הקשר של המשרד.'

export const NO_CONTACTS_MESSAGE = 'לא הוגדרו פרטי קשר למשרד'

export const NO_SHAREABLE_CONTACTS_MESSAGE = 'אף אחד מפרטי הקשר של המשרד אינו מאושר לשיתוף'

const CONTACT_TYPES = ['email', 'phone', 'whatsapp']

const OFFERED_FLAGS = ['shareable']

export default function SendContactsStep({
    contacts,
    editable,
    shareableIds,
    selectedIds,
    onToggle,
    onApproved,
}) {
    const hasContactRows = contacts.items.some((detail) => CONTACT_TYPES.includes(detail.type))
    const showsNoShareableWarning = hasContactRows && shareableIds.length === 0

    const storeFlagChange = async (id, key, wanted) => {
        const detail = contacts.items.find((item) => item.id === id)
        const flags = withFlag(detail?.flags, key, wanted)
        const outcome = await contacts.update(id, { flags })

        if (outcome.refused != null) {
            throw outcome.refused
        }

        if (wanted) {
            onApproved?.(id)
        }
    }

    const updateDetail = ({ id, ...input }) => contacts.update(id, input)

    return (
        <Stack spacing={2}>
            <StepHeader>{CONTACTS_HEADER}</StepHeader>

            <Alert severity="info" data-testid="next-step-hint">{CONTACTS_NEXT_HINT}</Alert>

            {!editable && (
                <Alert severity="warning" data-testid="contacts-read-only">{CONTACTS_READ_ONLY_MESSAGE}</Alert>
            )}

            {showsNoShareableWarning && (
                <Alert severity="warning" data-testid="contacts-none-shareable">{NO_SHAREABLE_CONTACTS_MESSAGE}</Alert>
            )}

            <ContactDetailsSection
                emptyMessage={NO_CONTACTS_MESSAGE}
                details={contacts.items}
                onAdd={contacts.create}
                onUpdate={updateDetail}
                onRemove={contacts.remove}
                onRestore={contacts.restore}
                onConfirmRemoval={contacts.confirmRemoval}
                refusals={contacts.refusals}
                onFlagChange={storeFlagChange}
                types={CONTACT_TYPES}
                flags={OFFERED_FLAGS}
                reorderable={false}
                readOnly={!editable}
                selection={{
                    kind: 'checkbox',
                    selectedIds,
                    selectableIds: shareableIds,
                    onSelect: onToggle,
                }}
            />
        </Stack>
    )
}
